import React, { Component } from "react";
import { MapCategory } from "../../../interfaces/map/common.interfaces";
import styles from './category-list-entry.module.css';
import { getIconFromIdentifier } from '../../../utils/map.utils';

type CategoryListEntryProps = {
    category: MapCategory;
    isActive?: boolean;
    onClick: () => void;
    language?: string;
}

type CategoryListEntryState = {}

class CategoryListEntry extends Component<CategoryListEntryProps, CategoryListEntryState> {

    render() {
        const { category, isActive, language, onClick } = this.props;
        const title = language && language?.includes("en") ? category.pageTitle_en : category.pageTitle;
        const iconSource = getIconFromIdentifier(category.identifier);
        return (
            <div>
                <button
                    className={`${styles.entry}${isActive ? ` ${styles.entryActive}` : ''}`}
                    onClick={onClick}
                >
                    <input
                        className={styles.checkbox}
                        type="checkbox"
                        checked={!!isActive}
                        readOnly
                        tabIndex={-1}
                    />
                    <p className={`${styles.entryTitle}${isActive ? ` ${styles.entryTitleActive}` : ''}`}>{title}</p>
                    {iconSource && (
                        <img className={styles.icon} src={iconSource}></img>
                    )}
                </button>
            </div>
        );
    }
}

export default CategoryListEntry;
